import { ForwardedRef, forwardRef, ReactNode } from 'react';

interface InputHelperTextProps {
  dataTestIdPrefix?: string;
  children: ReactNode | string;
  className: string;
}
const InputHelperText = forwardRef(
  (props: InputHelperTextProps, ref?: ForwardedRef<HTMLFormElement>) => {
    return (
      <span
        data-testid={props.dataTestIdPrefix}
        className={props.className}
        ref={ref}
      >
        {props.children}
      </span>
    );
  }
);

export default InputHelperText;
